import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class StorageService {


  constructor() {

  }


  writeSession(key, value) {
    sessionStorage.setItem(key, value);
  }

  readSession(key) {
    return sessionStorage.getItem(key);
  }
  removeSession(key) {
    sessionStorage.removeItem(key);
  }
  clearSession() {
    sessionStorage.clear();
  }



  writeCache(key, value) {
    // TODO:Fill method
  }

  readCache(key) {
    // TODO:Fill method
  }
  removeCache(key) {
    // TODO:Fill method
  }
  clearCache() {
    // TODO:Fill method
  }

}
